import dayjs from "dayjs"
import { RecurrenceEndType, RecurrenceUnit, RecurringSchedule } from "../../../../domain/recurringSchedule"

export const setIsRecurring = (schedule: RecurringSchedule, isRecurring: boolean): RecurringSchedule => {
  return {
    ...schedule,
    isRecurring,
  }
}

export const setRepeatCount = (schedule: RecurringSchedule, repeatCount: number): RecurringSchedule => {
  return {
    ...schedule,
    repeatCount,
  }
}

export const setRepeatUnits = (schedule: RecurringSchedule, repeatUnits: RecurrenceUnit): RecurringSchedule => {
  return {
    ...schedule,
    repeatUnits,
  }
}

export const setEndType = (schedule: RecurringSchedule, endType: RecurrenceEndType): RecurringSchedule => {
  return {
    ...schedule,
    endType,
  }
}

export const setOccurrences = (schedule: RecurringSchedule, occurrences: number): RecurringSchedule => {
  return {
    ...schedule,
    occurrences,
  }
}

export const setDateRange = (schedule: RecurringSchedule, startDate: dayjs.Dayjs, endDate: dayjs.Dayjs): RecurringSchedule => {
  return {
    ...schedule,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  }
}
